"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrixelRangeDatePicker = _interopRequireDefault(require("../BrixelRangeDatePicker"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function BrixelInputRangeDatePicker(props) {
  const {
    className = '',
    hasButtonChoice = false,
    inline = false,
    input,
    label = null,
    lang,
    labelLeft = null,
    large = false,
    maxDate = undefined,
    minDate = undefined,
    ref1 = null,
    ref2 = null,
    ref3 = null,
    ref4 = null
  } = props;
  const changeStartValue = val => {
    if (input.onChangeStartValue) input.onChangeStartValue(val);
  };
  const changeEndValue = val => {
    if (input.onChangeEndValue) input.onChangeEndValue(val);
  };
  const onClick = val => {
    if (input.onClick) input.onClick(val);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-input-datepicker ${large ? 'large' : ''}`
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: `${labelLeft ? 'txtText600 mb-2 dis-b' : 'brixel-label'} ${large ? 'labelLarge' : ''}`,
    htmlFor: input.name
  }, label)), /*#__PURE__*/_react.default.createElement(_BrixelRangeDatePicker.default, {
    className: className,
    dateFormat: "dd/MM/yyyy",
    lang: lang,
    hasButtonChoice: hasButtonChoice,
    inline: inline,
    minDate: minDate,
    maxDate: maxDate,
    ref1: ref1,
    ref2: ref2,
    ref3: ref3,
    ref4: ref4,
    onChangeStartRange: val => changeStartValue(val),
    onChangeEndRange: val => changeEndValue(val),
    onClick: val => onClick(val),
    startOpen: false,
    selectedStart: input.startValue,
    selectedEnd: input.endValue
  }));
}
var _default = exports.default = BrixelInputRangeDatePicker;